<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() { },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Microsoft YaHei, Hiragino Sans GB, sans-serif;
}

li {
  list-style-type: none;
  list-style-position: outside;
}

body,
html,
#app,
.bgc {
  width: 100%;
}

#app {
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, #F8FBDE 0%, #3ADDFF 63.5%, #2F97FF 100%);
  font-family: Helvetica !important;
}
</style>
